import Link from 'components/Link';
import React from 'react';
import {concatenate} from "services/string";
import {Icon} from "types/Icon";

type Props = {
  href: string
  name: string
  description?: string | null
  backgroundSrc?: string | null | false
  icon?: Icon
}

function Chip(props: Props) {
  const {name, description, backgroundSrc, href} = props
  const Icon = props.icon

  const initials = name.match(/[A-Z]/g)?.slice(0, 3).join('') ?? name.slice(0,3).toUpperCase();

  return (
    <div className="col-span-1 flex shadow-sm rounded-md h-16">
      <div
        className={concatenate(!backgroundSrc && 'bg-brand', 'flex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md')}>
        {backgroundSrc &&
          <img src={backgroundSrc} alt={name}
               className="object-cover object-center h-full w-full border border-r-0 border-gray-200 rounded-l-md"/>
        }

        {!backgroundSrc && Icon &&
          <Icon className="h-5 w-5"/>
        }

        {!backgroundSrc && !Icon &&
          initials
        }
      </div>

      <div
        className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
        <div className="flex-1 px-4 py-2 text-sm truncate">
          <Link to={href} noDecoration>{name}</Link>
          {description ? <p className="text-gray-500">{description}</p> : null}
        </div>

        {/*<div className="flex-shrink-0 pr-2">*/}
        {/*    <button*/}
        {/*        type="button"*/}
        {/*        className="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand"*/}
        {/*    >*/}
        {/*        <span className="sr-only">Open options</span>*/}
        {/*        <DotsVerticalIcon className="w-5 h-5" aria-hidden="true" />*/}
        {/*    </button>*/}
        {/*</div>*/}
      </div>
    </div>
  );
}

export default Chip;